import * as React from 'react';
import { useFormContext, Controller, ValidationRule } from 'react-hook-form';
import CheckBox, { IProps as IComponentProps } from '../CheckBox';

interface IProps extends Omit<IComponentProps, 'errors' | 'onChange'> {
  name: string;
  validate?: ValidationRule;
}

const FormCheckBox: React.FC<IProps> = ({ name, validate, ...checkProps }) => {
  const { control } = useFormContext();

  return (
    <Controller
      rules={validate}
      name={name}
      control={control}
      defaultValue={[]}
      render={({ field }) => <CheckBox {...checkProps} id={name} onChange={field.onChange} />}
    />
  );
};

export default FormCheckBox;
